import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

export default function PrivacyPage() {
  const { lang } = useLanguage();
  const isAr = lang === 'ar';
  const displayFont = isAr ? 'var(--font-ar-display)' : 'var(--font-en-display)';

  return (
    <div data-testid="privacy-page">
      <section className="bg-gradient-to-br from-[#0B2F44] to-[#071E2C] pt-28 pb-12">
        <div className="max-w-[900px] mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl font-bold text-white" style={{ fontFamily: displayFont }}>
            {isAr ? 'سياسة الخصوصية' : 'Privacy Policy'}
          </h1>
          <p className="text-white/50 mt-3 text-sm">{isAr ? 'آخر تحديث: أبريل 2026' : 'Last updated: April 2026'}</p>
        </div>
      </section>

      <section className="bg-[#F8FAFB] py-16">
        <div className="max-w-[900px] mx-auto px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 lg:p-12 border border-[#D0D8DC]/50 shadow-sm prose prose-sm max-w-none" style={{ lineHeight: isAr ? '2' : '1.8' }}>
            <h2 className="text-lg font-bold text-[#0B2F44]" style={{ fontFamily: displayFont }}>
              {isAr ? '1. المقدمة' : '1. Introduction'}
            </h2>
            <p className="text-[#4A6572] text-sm">
              {isAr
                ? 'جُليد للرهن العقاري (Guleed Mortgage) ملتزمة بحماية خصوصية عملائنا وزوار موقعنا. توضح هذه السياسة كيفية جمع واستخدام وحماية معلوماتك الشخصية وفقاً للمرسوم بقانون اتحادي رقم 45 لسنة 2021 بشأن حماية البيانات الشخصية في دولة الإمارات.'
                : 'Guleed Mortgages Real Estate LLC (Guleed Mortgage) is committed to protecting the privacy of our clients and website visitors. This policy explains how we collect, use, and protect your personal information in compliance with UAE Federal Decree-Law No. 45 of 2021 on Personal Data Protection.'}
            </p>

            <h2 className="text-lg font-bold text-[#0B2F44] mt-8" style={{ fontFamily: displayFont }}>
              {isAr ? '2. البيانات التي نجمعها' : '2. Data We Collect'}
            </h2>
            <p className="text-[#4A6572] text-sm">
              {isAr ? 'نجمع البيانات التالية:' : 'We collect the following data:'}
            </p>
            <ul className="text-[#4A6572] text-sm space-y-1 list-disc ps-5">
              <li>{isAr ? 'معلومات الاتصال (الاسم، البريد الإلكتروني، رقم الهاتف)' : 'Contact information (name, email, phone number)'}</li>
              <li>{isAr ? 'المعلومات المالية (الراتب، حالة التوظيف) لأغراض تقييم التمويل' : 'Financial information (salary, employment status) for mortgage assessment'}</li>
              <li>{isAr ? 'المستندات المرفوعة عبر بوابة العميل' : 'Documents uploaded through the client portal'}</li>
              <li>{isAr ? 'بيانات التصفح وملفات تعريف الارتباط' : 'Browsing data and cookies'}</li>
            </ul>

            <h2 className="text-lg font-bold text-[#0B2F44] mt-8" style={{ fontFamily: displayFont }}>
              {isAr ? '3. كيف نستخدم بياناتك' : '3. How We Use Your Data'}
            </h2>
            <ul className="text-[#4A6572] text-sm space-y-1 list-disc ps-5">
              <li>{isAr ? 'معالجة طلبات التمويل العقاري' : 'Processing mortgage applications'}</li>
              <li>{isAr ? 'التواصل معك بشأن خدماتنا' : 'Communicating with you about our services'}</li>
              <li>{isAr ? 'تحسين موقعنا وخدماتنا' : 'Improving our website and services'}</li>
              <li>{isAr ? 'الامتثال للمتطلبات القانونية والتنظيمية' : 'Compliance with legal and regulatory requirements'}</li>
            </ul>

            <h2 className="text-lg font-bold text-[#0B2F44] mt-8" style={{ fontFamily: displayFont }}>
              {isAr ? '4. حماية البيانات' : '4. Data Protection'}
            </h2>
            <p className="text-[#4A6572] text-sm">
              {isAr
                ? 'جميع البيانات الشخصية مشفرة أثناء النقل والتخزين باستخدام تشفير AES-256. المستندات المرفوعة مخزنة بشكل آمن مع وصول محدود. نجري اختبارات أمان دورية لضمان حماية بياناتك.'
                : 'All personal data is encrypted in transit and at rest using AES-256 encryption. Uploaded documents are stored securely with restricted access. We conduct regular security audits to ensure your data protection.'}
            </p>

            <h2 className="text-lg font-bold text-[#0B2F44] mt-8" style={{ fontFamily: displayFont }}>
              {isAr ? '5. حقوقك' : '5. Your Rights'}
            </h2>
            <p className="text-[#4A6572] text-sm">
              {isAr
                ? 'لديك الحق في الوصول إلى بياناتك الشخصية، تصحيحها، حذفها، أو طلب نقلها. للاستفسار عن بياناتك، تواصل معنا على info@gmreae.com.'
                : 'You have the right to access, correct, delete, or request transfer of your personal data. For data inquiries, contact us at info@gmreae.com.'}
            </p>

            <h2 className="text-lg font-bold text-[#0B2F44] mt-8" style={{ fontFamily: displayFont }}>
              {isAr ? '6. ملفات تعريف الارتباط' : '6. Cookies'}
            </h2>
            <p className="text-[#4A6572] text-sm">
              {isAr
                ? 'نستخدم ملفات تعريف الارتباط الأساسية لتشغيل الموقع وملفات التحليل لتحسين تجربتك. يمكنك إدارة تفضيلات الكوكيز من خلال بانر الموافقة على الموقع.'
                : 'We use essential cookies for site functionality and analytics cookies to improve your experience. You can manage cookie preferences through the consent banner on our site.'}
            </p>

            <h2 className="text-lg font-bold text-[#0B2F44] mt-8" style={{ fontFamily: displayFont }}>
              {isAr ? '7. الاتصال بنا' : '7. Contact Us'}
            </h2>
            <p className="text-[#4A6572] text-sm">
              {isAr ? 'للاستفسارات المتعلقة بالخصوصية:' : 'For privacy-related inquiries:'}
              <br />info@gmreae.com | +971 52 289 8249
              <br />{isAr ? 'برج 3 أشرعة، الكورنيش، أبوظبي، الإمارات' : '3 Sails Tower, Corniche, Abu Dhabi, UAE'}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
